import { Directive, HostListener, input, model } from '@angular/core';
import { FormControl } from '@angular/forms';

@Directive({
  selector: '[sharedCoreNextFormControlInputOnKeydownDirective]',
})
export class NextFormControlInputOnKeydownDirective {
  readonly listenerKeycode = input<string>('Enter');
  readonly formControlsInAppearanceOrder = input.required<FormControl[]>();

  readonly currentIndex = model.required<number | undefined>();

  @HostListener('window:keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    if (event.key !== this.listenerKeycode()) return;

    const currentIndex = this.currentIndex();

    if (currentIndex === undefined) return;

    const currentFormControl = this.formControlsInAppearanceOrder()[currentIndex];
    if (currentFormControl.invalid) {
      currentFormControl.markAsTouched();

      return;
    }

    if (currentIndex >= this.formControlsInAppearanceOrder().length - 1) {
      this.currentIndex.set(undefined);
      return;
    }

    this.currentIndex.set(currentIndex + 1);
  }
}
